<template>
    <!-- Promo Section -->
    <section class="promo-section position-relative" v-if="offer">
        <div class="container-fluid p-0">
            <div class="row g-0">
                <div class="col-md-6 bg-dark-brown text-white p-5 d-flex flex-column justify-content-center">
                    <div class="p-4">
                        <span class="text-warning small fw-bold ls-1">BEST OPTIONS!</span>
                        <h2 class="display-4 fw-bold font-serif mb-4 mt-2">{{ offer.name }}</h2>
                        <p class="small text-white-50 mb-4">Special offers for members, including seamless tracking of
                            your points and redemption history.</p>

                        <div class="d-flex gap-4 mb-4">
                            <div class="text-center">
                                <div class="bg-white text-dark rounded-3 px-3 py-2 fw-bold">{{ timer.days }}</div>
                                <span class="small mt-1 d-block">Days</span>
                            </div>
                            <div class="text-center">
                                <div class="bg-white text-dark rounded-3 px-3 py-2 fw-bold">{{ timer.hours }}</div>
                                <span class="small mt-1 d-block">Hours</span>
                            </div>
                            <div class="text-center">
                                <div class="bg-white text-dark rounded-3 px-3 py-2 fw-bold">{{ timer.minutes }}</div>
                                <span class="small mt-1 d-block">Mins</span>
                            </div>
                            <div class="text-center">
                                <div class="bg-white text-dark rounded-3 px-3 py-2 fw-bold">{{ timer.seconds }}</div>
                                <span class="small mt-1 d-block">Secs</span>
                            </div>
                        </div>

                        <a :href="offer.link" class="btn btn-light rounded-pill px-4">View Collection <i
                                class="bi bi-arrow-right ms-2"></i></a>
                    </div>
                </div>
                <div class="col-md-6 position-relative bg-danger" style="min-height: 500px;">
                    <img :src="offer.image" id="promo-img"
                        class="position-absolute w-100 h-100 object-fit-cover" :alt="offer.name">
                </div>
            </div>
            <!-- Circular Badge Overlap -->
            <div class="position-absolute start-50 top-50 translate-middle" style="z-index:10;">
                <div class="bg-danger-subtle rounded-circle d-flex align-items-center justify-content-center text-danger fw-bold shadow-lg"
                    style="width: 100px; height: 100px;">
                    {{ offer.discount }}% OFF
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "PromoSection",
    props: {
        offer: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            timer: {
                days: '00',
                hours: '00',
                minutes: '00',
                seconds: '00'
            },
            interval: null
        }
    },
    mounted() {
        if (this.offer && this.offer.expire_at) {
            this.startTimer();
        }
    },
    watch: {
        offer(newOffer) {
            if (newOffer && newOffer.expire_at) {
                this.startTimer();
            }
        }
    },
    beforeDestroy() {
        if (this.interval) clearInterval(this.interval);
    },
    methods: {
        startTimer() {
            if (this.interval) clearInterval(this.interval);
            
            const endDate = new Date(this.offer.expire_at).getTime();
            
            this.updateTimer(endDate);
            
            this.interval = setInterval(() => {
                this.updateTimer(endDate);
            }, 1000);
        },
        updateTimer(endDate) {
            const now = new Date().getTime();
            const distance = endDate - now;
            
            if (distance < 0) {
                clearInterval(this.interval);
                this.timer = { days: '00', hours: '00', minutes: '00', seconds: '00' };
                return;
            }
            
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            
            this.timer = {
                days: String(days).padStart(2, '0'),
                hours: String(hours).padStart(2, '0'),
                minutes: String(minutes).padStart(2, '0'),
                seconds: String(seconds).padStart(2, '0')
            };
        }
    }
}
</script>
